import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import { TableColumn } from '../../../components/kiene-table/table-column';
import { TableDescriptor, ToolbarButton } from '../../../components/kiene-table/table-descriptor';
import { TableOption } from '../../../components/kiene-table/table-option';
import { ConfirmDeleteDialogComponent } from '../../../dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { Preisgruppe, PreisgruppeArtikel } from '../preisgruppen';
import { AddPreisgruppeArtikelComponent } from './add-preisgruppe-artikel/add-preisgruppe-artikel.component';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({
    selector: 'kiene-preisgruppe-artikel',
    templateUrl: './preisgruppe-artikel.component.html',
    styleUrls: ['./preisgruppe-artikel.component.scss'],
})
export class PreisgruppeArtikelComponent implements OnInit, OnDestroy {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    preisgruppe_id: string = null;

    constructor(
        public dialog: MatDialog,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private tableService: KieneTableService,
        private messageService: MessageService,
        private route: ActivatedRoute,
    ) {}

    ngOnDestroy(): void {
        this.tableService = null;
    }

    ngOnInit() {
        this.preisgruppe_id = this.route.snapshot.paramMap.get('id');
        this.loadPreisgruppe(this.preisgruppe_id);
        this.tableDescriptor.params = new HttpParams().set('preisgruppe_id', this.preisgruppe_id);

        this.tableDescriptor.headline = 'Preisgruppen Artikel';
        this.tableDescriptor.uniqueIdentifier = 'Preisgruppen Artikel';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'preisgruppe_artikel/';
        this.tableDescriptor.searchPlaceholder = 'Preisgruppen Artikel durchsuchen';
        this.tableDescriptor.createAllowed = false;
        this.tableDescriptor.columns.push(new TableColumn('preisgruppe', 'Preisgruppe'));
        this.tableDescriptor.columns.push(new TableColumn('artikel', 'Artikel'));
        this.tableDescriptor.columns.push(new TableColumn('vk', 'VK'));
        this.tableDescriptor.columns.push(new TableColumn('vkpreis', 'VK-Preis (€)'));
        this.tableDescriptor.columns.push(new TableColumn('einzelpreis', 'Verkaufspreis (€)'));
        this.tableDescriptor.columns.push(new TableColumn('einkaufspreis', 'Rab. Einkaufspreis (€)'));
        this.tableDescriptor.columns.push(new TableColumn('handelsspanne', 'Handelsspanne (%)'));
        this.tableDescriptor.columns.push(new TableColumn('rohertrag', 'Rohertrag (€)'));
        this.tableDescriptor.columns.push(new TableColumn('kalkulationszuschlag', 'Kalkulationszuschlag (%)'));
        this.tableDescriptor.columns.push(new TableColumn('editiert', 'Editiert', 'datetime'));

        this.tableDescriptor.showDetails = false;

        this.tableDescriptor.permissionCreate = 2982;
        this.tableDescriptor.permissionView = 2981;

        this.tableDescriptor.initialSortColumn = 'artikel';
        this.tableDescriptor.initialSortDirection = 'asc';

        this.tableDescriptor.toolbarButtons.push(new ToolbarButton(this.addPreisgruppeArtikel.bind(this), 'add', 2982));

        this.tableDescriptor.options.push(
            new TableOption(this.openAddPreisgruppeArtikelDialog.bind(this), 'Editieren', 'edit', 2982),
        );
        this.tableDescriptor.options.push(new TableOption(this.openDeleteDialog.bind(this), 'Löschen', 'delete', 2984));
    }

    public addPreisgruppeArtikel() {
        this.openAddPreisgruppeArtikelDialog(null);
    }

    openAddPreisgruppeArtikelDialog(preisgruppeArtikel: PreisgruppeArtikel) {
        if (this.preisgruppe_id === null || this.preisgruppe_id === undefined) {
            this.messageService.errorMessage('Ungültige Preisgruppe', null);
        } else {
            let dialogRef = this.dialog.open(AddPreisgruppeArtikelComponent, {
                width: '50%',
                minWidth: '300px',
                data: { preisgruppeArtikel: preisgruppeArtikel, preisgruppe_id: this.preisgruppe_id },
            });

            dialogRef.afterClosed().subscribe(() => {
                this.tableService.reload();
            });
        }
    }

    openDeleteDialog(preisgruppeArtikel: PreisgruppeArtikel) {
        let dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
            width: '500px',
            data: { title: 'Preisgruppenartikel wirklich löschen?', text: 'Preisgruppenartikel wirklich löschen?' },
        });

        dialogRef.afterClosed().subscribe(response => {
            if (response) {
                this.tableService
                    .deleteEntity(this.apiBaseUrl + 'preisgruppe_artikel/delete.php', preisgruppeArtikel)
                    .subscribe(
                        () => {
                            this.messageService.infoMessage('Der Preisgruppeartikel wurde erfolgreich gelöscht!');
                            this.tableService.reload();
                        },
                        error => {
                            this.messageService.errorMessage(
                                'Der Preisgruppenartikel konnte nicht gelöscht werden! ',
                                error,
                            );
                        },
                    );
            }
        });
    }

    loadPreisgruppe(preisgruppe_id: string) {
        if (preisgruppe_id !== null && preisgruppe_id !== undefined) {
            this.tableService
                .getOne(this.apiBaseUrl + 'preisgruppe/read_one.php', 'preisgruppe_id', preisgruppe_id)
                .subscribe(response => {
                    let preisgruppe: Preisgruppe = response;
                    this.tableDescriptor.headline = 'Preisgruppen Artikel (' + preisgruppe.bezeichnung + ')';
                });
        }
    }
}
